import { render, staticRenderFns } from "./UserForms.vue?vue&type=template&id=004c0a1e&scoped=true&"
import script from "./UserForms.vue?vue&type=script&lang=js&"
export * from "./UserForms.vue?vue&type=script&lang=js&"
import style0 from "./UserForms.vue?vue&type=style&index=0&id=004c0a1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c0a1e",
  null
  
)

export default component.exports